var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef } from '@angular/core';
import { IntegerWidget as _IntegerWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var IntegerWidget = (function (_super) {
    __extends(IntegerWidget, _super);
    function IntegerWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(IntegerWidget.prototype, "prefix", {
        get: function () {
            return (this.schema.options && this.schema.options.prefix) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IntegerWidget.prototype, "suffix", {
        get: function () {
            return (this.schema.options && this.schema.options.suffix) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IntegerWidget.prototype, "step", {
        get: function () {
            // `number` accepts decimals; `integer` is whole-number only. Without a step the
            // browser defaults to 1 and rejects typed decimals on number fields.
            return this.schema.type === 'integer' ? '1' : 'any';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IntegerWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    IntegerWidget.prototype.ngAfterViewInit = function () {
        var _this = this;
        var control = this.control;
        this.formProperty.valueChanges.subscribe(function (newValue) {
            if (typeof _this._displayValue !== 'undefined') {
                // Ignore the model value, use the display value instead
                if (control.value !== _this._displayValue) {
                    control.setValue(_this._displayValue, { emitEvent: false });
                }
            }
            else {
                if (control.value !== newValue) {
                    control.setValue(newValue, { emitEvent: false });
                }
            }
        });
        this.formProperty.errorsChanges.subscribe(function (errors) {
            control.setErrors(errors, { emitEvent: true });
            var messages = (errors || [])
                .filter(function (e) {
                return e.path && e.path.slice(1) === _this.formProperty.path;
            })
                .map(function (e) { return e.message; });
            _this.errorMessages = messages.filter(function (m, i) { return messages.indexOf(m) === i; });
        });
        control.valueChanges.subscribe(function (newValue) {
            _this._displayValue = newValue;
            _this.formProperty.setValue(newValue, false);
            delete _this._displayValue;
            if (newValue === '' && _this.element.nativeElement.validity.badInput) {
                // Show a custom error instead
                _this.formProperty.extendErrors([{
                        path: '#' + _this.formProperty.path,
                        message: 'Invalid number',
                    }]);
            }
        });
    };
    return IntegerWidget;
}(_IntegerWidget));
export { IntegerWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/integer.widget.ts.pre-build-optimizer.js